import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import Project from '@/models/Project';
import { ProjectShortInfo } from '@/modules/Chat/interfaces/ProjectShortInfo';
import { convertProjectsToProjectInfo } from '@/modules/Chat/helpers/ChatHelper';
import ChatContentHeader from '@/modules/Chat/components/ChatContentHeader.vue';
import NoMessages from '@/modules/Chat/components/NoMessages.vue';
import ChatMessageList from '@/modules/Chat/components/ChatMessageList.vue';
import ChatInputArea from '@/modules/Chat/components/ChatInputArea.vue';
import ChatRepository from '@/modules/Chat/api/repositories/ChatRepository';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatContent',
  props: {
    project: {
        type: Object as PropType<Project | null>,
        default: null,
    },
    selectedProjectId: {
        type: String as PropType<string | null>,
        default: null,
    },
    isInProjectView: {
        type: Boolean,
        default: false,
    },
    isProjectInRequestState: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;



const projectInfo = computed(() => {
    if (props.project === null) {
        return null;
    }

    return convertProjectsToProjectInfo(props.project) as ProjectShortInfo;
});

const messageList = computed(() => {
    if (props.project == null || props.project.chat == null) {
        return [];
    }

    return ChatRepository.getMessagedFromChatById(props.project.chat.id);
});

const chatId = computed(() => {
    if (props.project == null || props.project.chat == null) {
        return null;
    }

    return props.project.chat.id;
});

return { __sfc: true,props, projectInfo, messageList, chatId, ChatContentHeader, NoMessages, ChatMessageList, ChatInputArea }
}

})